import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addYourResidence } from "../../redux/slices/registerSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { googleEvent_LOJ079 } from "../../lib/google-analytics-loan-journey-events";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";
import { googleEvent_LOJ081 } from "../../lib/google-analytics";

export default function YourResidence() {
  const [loading, setLoading] = useState(false);

  const { yourResidence } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { enterYourResidence } = new ServicesAPI();
  const { handleStep } = useResponse();

  const data = ["Owned", "Rented"];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);

    const res = await enterYourResidence(data);

    if (res && res.statusCode === 200) {
      dispatch(addYourResidence(data.value));

      if (repeatCustomer) {
        navigate("/confirm-details");
      } else {
        handleStep();
      }
    } else if (res && res.statusCode === 400) {
      Swal.fire({
        icon: "error",
        text: res.message,
        timer: 3000,
      });

      setTimeout(() => {
        window.location.href = "/dashboard";
      }, 5000);
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ079();
  }, []);

  useEffect(() => {
    if(loading) {
      handleShowContextualLoader("Please wait...");
      return;
    } else {
      handlehideContextualLoader();
    }
    return () => {
      handlehideContextualLoader();
    };
  }, [loading]);

  return (
    <>
      <div className="wrapper">
        <MainHeader
          title="Residential Details"
          showProgress={true}
          percent={92.28}
          backPageName={repeatCustomer ? "/confirm-details" : ""}
        />
        <div className="mb-3">
          <p className="label">Your Residence</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "residenceType",
                value: item,
              });

              googleEvent_LOJ081(item);
            }}
          >
            <SelectOption name={item} checked={yourResidence} />
          </div>
        ))}
      </div>
    </>
  );
}
